/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TacticalMeetingChecklistItemsView_circle$ref: FragmentReference;
declare export opaque type TacticalMeetingChecklistItemsView_circle$fragmentType: TacticalMeetingChecklistItemsView_circle$ref;
export type TacticalMeetingChecklistItemsView_circle = {|
  +databaseId: string,
  +organization: {|
    +id: string,
    +databaseId: string,
  |},
  +supportedRole: ?{|
    +databaseId: string
  |},
  +$refType: TacticalMeetingChecklistItemsView_circle$ref,
|};
export type TacticalMeetingChecklistItemsView_circle$data = TacticalMeetingChecklistItemsView_circle;
export type TacticalMeetingChecklistItemsView_circle$key = {
  +$data?: TacticalMeetingChecklistItemsView_circle$data,
  +$fragmentRefs: TacticalMeetingChecklistItemsView_circle$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TacticalMeetingChecklistItemsView_circle",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "supportedRole",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Circle",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '06079d3a6ca7b874b604655e9bb55bce';

module.exports = node;
